import {
    Component,
    OnInit,
    Input,
    Output,
    EventEmitter,
} from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ShareDocumentComponent } from '../share-document/share-document.component';
import { Router } from '@angular/router';
import { AppState } from '../../../../app.reducer';
import { Store } from '@ngrx/store';
import { DeleteFile, DownloadDocument, SearchDocuments } from "../_store/resources.actions";

import { MoveFilesComponent } from '../move-files-dialogue/move-files.component';
import { NotificationModalComponent } from 'src/app/features/common-components/notification-modal/notification-modal.component';
import { inputs } from '@syncfusion/ej2-angular-gantt/src/gantt/gantt.component';
import { LoaderShow } from 'src/app/features/loader/store/loader.actions';
import { take } from 'rxjs/operators';


@Component({
    selector: 'each-document',
    templateUrl: './document.component.html',
    styleUrls: ['./document.component.scss']
})
export class DocumentComponent implements OnInit {
    @Input() document: any = {};
    @Input() showOptions: boolean = false;
    @Input() showStatus: boolean = false;
    @Input() showUploadedBy: boolean = false;
    @Input() listView: boolean = false;
    @Input() callType: string = '';
    endPoint: string;
    resultantTags: any;
    @Input() currentFolderId;
    @Output() clickedDocumentEvent: EventEmitter<any> = new EventEmitter();
    @Input() searchString: any = '';
    @Input() fromAllCmpDocuments: boolean = false;
    userId: any;
    // tagToBeShown : String;
    constructor(private dialog: MatDialog, public router: Router, public store: Store<AppState>) {

    }

    ngOnInit() {
        this.store.select(state => state.auth.user).pipe(
            take(1)
          ).subscribe(user => {
            if (user) {
              this.userId = user.details._id;
            }
          });
        let url = this.router.routerState.snapshot.url;
        // console.log(url, "url")
        this.endPoint = url.split('/').pop();
        
        let tags = this.document.tags;
        // // console.log('TCL: tags', tags);
        let tagsArray = tags.map(tag => tag.tag || tag);

        this.resultantTags = this.displayTags(tagsArray);
        
        // console.log('TCL: tagsArray', tagsArray);
        // let tagsString = tagsArray.join(", ")
        // if (tagsString.length <= 20) {
        //     this.tagToBeShown = tagsString
        // }
        // else {
        //     this.tagToBeShown = this.trimTags(tagsString, 13)
        // }
        // console.log('TCL: this.tagToBeShown', this.tagToBeShown);
    }
    goToShareDocument() {
        const dialogRef = this.dialog.open(ShareDocumentComponent, {
            width: '60%',
            data: {
                documentId: this.document._id,
            }
        });
        dialogRef.afterClosed().subscribe(result => console.log("dialog closed", result));
    }
    onDocClick(document) {

        if (this.endPoint === 'inbox') {
            this.clickedDocumentEvent.emit({ document: document });
        } else if (this.callType) {
            this.clickedDocumentEvent.emit({ document: document });
            console.log('im called');
        } else {
            let docId = document._id ? document._id : document.id;
            if(this.router.url.includes('citis')){
                this.router.navigate(['./home/resources/doc/'+ docId +'/detail/citiis/'+this.currentFolderId]);
            }else{
                this.router.navigate(['./home/resources/doc/' + docId]);
            }
        }
    }


    openMoveDialogue(fileID: string = '', fileFlag: boolean = false) {
        console.log(fileID);
        const dialogRef = this.dialog.open(MoveFilesComponent, {
            width: '50%',
            panelClass: 'compose-mailbox',
            data: {
                fileId: fileID,
                Flag: fileFlag,
                currentFolderId: this.currentFolderId
            }
        });
        dialogRef.afterClosed().subscribe(result => {
            if (result) {

            }
        });
    }


    deleteDoc(id) {
        const dialogRef = this.dialog.open(NotificationModalComponent, {
            width: '500px',
            panelClass: 'cmp-modal',
            data: {
                text: 'Are you sure you want to delete this document?'
            }
        });

        dialogRef.afterClosed().subscribe((response) => {
            if (response) {
                const payload = { isDeleted: true };
                this.store.dispatch(new DeleteFile(id, payload, this.currentFolderId));
                if (this.searchString.length) {
                    setTimeout(() => { this.store.dispatch(new SearchDocuments(this.searchString, { page: 1, limit: 10 })); }, 1000)
                }

            }
        });

    }

    downloadDocument(docObj) {
        console.log(docObj);


        this.store.dispatch(
            new DownloadDocument(
                docObj._id,
                docObj.fileName
            )
        );
    }
    // trimTags(tagsString, limit) {
    //     if (tagsString[limit-1] == " ")
    //         limit--;
    //     if (tagsString[limit-1] == ",")
    //         limit--;
    //     let output = tagsString.slice(0, limit) + "...";
    //     let rem = tagsString.slice(limit, tagsString.length - 1).split(",").length - 1
    //     if (rem > 0) {
    //         output += " +" + rem;
    //     }
    //     if (output.length < 20 && (tagsString[limit] != ' ' && tagsString[limit] != ',')) {
    //         limit++
    //         this.trimTags(tagsString,limit)
    //     }
    //     else {
    //         return (output)
    //     }
    // }
    // trimmedTags(tags){
    //     console.log('TCL: tags', tags);
    //     let tagsArray = tags.map(tag => tag.tag)
    //     let tagsString = tagsArray.join(", ")
    //     console.log('TCL: tagsString', tagsString);
    //     if (tagsString.length <= 20) {
    //         console.log('TCL: tagsString', tagsString);
    //         return(tagsString)
    //     }
    //     else {
    //         return this.trimTags(tagsString, 13)
    //         // return "Krishna"
    //     }
    // }

    displayTags(tagsArray) {
        let width = 15;
        let tags = [];
        tags = (tagsArray || []).reduce((accumulator, ele) => {
            if (width > 0) {
                if (ele && ele.length < width) {
                    width = width - ele.length;
                    accumulator.push(ele);
                } else {
                    if (ele) {
                        let temp = '';
                        temp = ele.slice(0, width);
                        width = width - temp.length;
                        if (temp.length !== ele.length) {temp = temp + '... '; }
                        accumulator.push(temp);
                    }
                }
            }
        return accumulator;
        }, []);
        const remain = tagsArray.length - tags.length;
        if (remain !== 0) {
            const remaining = '+' + remain;
            tags.push(remaining);
        }
        return tags;
    }

    isShowButtons() {
        let ownerId = this.document.owner ? this.document.owner._id : '';
        this.store.select(state => state.auth.user).pipe(
            take(1)
          ).subscribe(user => {
            if (user) {
              this.userId = user.details._id;
            }
          });
        // if (this.checkPermissions('delete-doc')) {
            if (this.router.url.includes('citis')) {
                return (this.checkPermissions('remove-doc-citiis-folder') && (ownerId == this.userId));
            } else {
                return this.checkPermissions('delete-doc')
            }
        // } else {
        //     return false
        // }

    }

    checkPermissions(type) {
        let isAllow = false;
        this.store.select(state => state.auth.user['capabilities']).subscribe(response => {
            if (response.length) {
                const capabilities = (response || []).reduce((acc, item) => {
                    return [...acc, ...item.capabilities];
                }, []);
                if (capabilities.includes(type)) {
                    isAllow = true
                } else {
                    isAllow = false;
                }
            }
        });
        return isAllow;
    }

    canShowMove(){
        if (this.router.url.includes('citis')) {
            return false
        }else{
            return true
        }
    }
}
